import validate from "/usr/src/app/content/n3-treatments-09ff3456-8b53-4936-b711-b1eafbe9c9df/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-09ff3456-8b53-4936-b711-b1eafbe9c9df/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}